var map = {
	"./Kambi/Rewards.resource.js": [
		37048,
		[
			9779
		]
	],
	"./Spectate/Rewards.resource.js": [
		27319,
		[
			9606
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 36133;
module.exports = webpackAsyncContext;